<section class="hero-sec">
    <div class="container-fluid flexer d-flex align-items-center justify-content-between gap-3">
      <div class="content">
        <div class="mob-title d-block d-md-none" i18n="home hero: dp education">DP Education.</div>
        <div class="title" i18n="home hero: title">A School for <span class="position-relative" style="font-family: 'Poppins Bold';"><img class="position-absolute"
          style="left: 0; bottom: 0px; width: 100%; max-width: 200px;" src="./assets/lines/2.png" alt="">Life</span></div>
        <div class="sub-title" i18n="home hero: sub title">We make learning engaging & effective, so that you are ready to achieve your goals.</div>
        <button [routerLink]="['/what-we-offer']" class="btn btn-learn-with-us" i18n="home hero: learn with us" >Learn With Us</button>
        <div class="our-brands-mini">
          <div class="label position-absolute top-0 translate-middle bg-white p-2" i18n="home hero: our brands">Our Brands</div>
          <div class="inner d-flex align-items-center h-100 px-3 text-center">
            <swiper #swiper [config]="config" (swiper)="onSwiper($event)" (slideChange)="onSlideChange()">
              <ng-template swiperSlide *ngFor="let brand of brands">
                <div class="tile">
                  <img class="brand-slide-img" src="./assets/images/brands/{{locale}}/{{brand.image}}" alt="">
                </div>
              </ng-template>
            </swiper>
          </div>
        </div>
      </div>
      <div class="fancy-img d-md-block d-none position-relative">
        <!-- <img class="position-absolute" style="z-index: 999;" src="./assets/images/seasonal/vesak.gif" alt=""> -->
        <div class="d-flex flex-wrap">
          <div class="img-box p-0" *ngFor="let url of imageUrls; let i = index">
            <img [src]="url" [ngClass]="{'special': specialImageIndices.includes(i), 'flip-animation': specialImageIndices.includes(i)}">
          </div>
        </div>
      </div>
    </div>
</section>

<section id="grades-sec" class="grades-sec">
  <div class="container-fluid">
    <div class="title text-center" i18n="home grades: choose your grade">Choose Your School <span class="position-relative" style="font-family: 'Poppins Bold';">Grade<img class="position-absolute"
        style="left: 0;
        bottom: -14px;
        width: 130px;" src="./assets/lines/1.png" alt=""></span></div>
      
    <div class="grid-container">
      <div class="grid">
        <ng-container *ngFor="let grade of grades">
          <a *ngIf="12 > grade['id']" class="tile" routerLink="/grade/{{grade['id']}}">{{ grade[locale]}}</a>
          <a *ngIf="grade['id'] >= 12" class="tile" routerLink="/grade/{{grade['id']}}/stream">{{ grade[locale]}}</a>
        </ng-container>
      </div>
    </div>
  </div>
</section>